jQuery(function($) {
  $(document).ready(function() {

    $('.partner-section').each(function() {
      var $container = $(this);

      $('.partner-region > h4 button', $container).on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        $('.partner-region.active', $container).append($('.partner-region__details ul', $container));

        $('.partner-region.active', $container).removeClass('active');
        var $region = $(this).closest('.partner-region');
        $region.addClass('active');

        // reset
        $('.partner-region__details', $container).removeClass('active');

        // add content
        $('.partner-region__details', $container).html($region.find('ul'));

        // fade in
        setTimeout(function() {
          $('.partner-region__details', $container).addClass('active');
        }, 10)

        return false;
      })

      $('.partner-region > h4 button', $container).first().click();
    })
  })
})
